export default "__VITE_ASSET__Dyf3SboG__"